
'use strict'

//import {WOW} from 'wowjs';
//import Menu from "./Menu";

class App {
    constructor() {
        this.main = document.getElementById('app');
        this._section = Section != null ? new Section() : null;
    }

}

export default App;